import _useMount from 'react-use/esm/useMount';
import {delay} from 'blend-promise-utils';

import utils from '@utils';

export const useMount = (
  setUser: React.Dispatch<
    React.SetStateAction<{
      attributes: {
        email: string;
      };
    }>
  >
) => {
  _useMount(async () => {
    // not authenticated防止のため、delayをかける
    await delay(1500);
    const user = await utils.amplify.getUser();

    setUser(user);
  });
};
